import getIsOnePaySubmission from "./onePayPaymentHelpers";

export default getIsOnePaySubmission;
